












import { Component, Vue } from "vue-property-decorator";
import lang from "@/config/language.config";
@Component({
  name: "langusge-switcher",
})
export default class LangusgeSwitcher extends Vue {
  languages = lang;

  changeLocale(locale: string): void {
    this.$i18n.locale = locale;
    localStorage.locale = locale;
  }
}
